import { useNavigate } from 'react-router-dom';
import Modal from '@/core/Modal';

function ModalAddContent({ onOpenChange, setOpenSheet }) {
  const navigate = useNavigate();
  return (
    <Modal
      className="gap-9 max-sm:gap-5 p-7"
      width="620"
      height="220"
      onOpenChange={onOpenChange}
      title="نوع محتوا خود را مشخص کنید"
    >
      <div className="grid gap-5 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 w-full [&_div]:cursor-pointer [&_div]:rounded-lg [&_div]:items-center [&_div]:justify-center [&_div]:gap-1.5 [&_div]:py-3 [&_div]:w-full [&_div]:border-1 [&_div]:flex [&_div]:flex-col">
        <div
          onClick={() => {
            onOpenChange(false);
            navigate('/ads/create');
          }}
          className="text-primary  border-primary bg-[#EFF4FF]"
        >
          <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              opacity="0.4"
              d="M40 16.5V36C40 42 36.42 44 32 44H16C11.58 44 8 42 8 36V16.5C8 10 11.58 8.5 16 8.5C16 9.74 16.4999 10.86 17.3199 11.68C18.1399 12.5 19.26 13 20.5 13H27.5C29.98 13 32 10.98 32 8.5C36.42 8.5 40 10 40 16.5Z"
              fill="#2563EB"
            />
            <path
              d="M32 8.5C32 10.98 29.98 13 27.5 13H20.5C19.26 13 18.1399 12.5 17.3199 11.68C16.4999 10.86 16 9.74 16 8.5C16 6.02 18.02 4 20.5 4H27.5C28.74 4 29.8601 4.50001 30.6801 5.32001C31.5001 6.14001 32 7.26 32 8.5Z"
              fill="#2563EB"
            />
            <path
              d="M24 27.5H16C15.18 27.5 14.5 26.82 14.5 26C14.5 25.18 15.18 24.5 16 24.5H24C24.82 24.5 25.5 25.18 25.5 26C25.5 26.82 24.82 27.5 24 27.5Z"
              fill="#2563EB"
            />
            <path
              d="M32 35.5H16C15.18 35.5 14.5 34.82 14.5 34C14.5 33.18 15.18 32.5 16 32.5H32C32.82 32.5 33.5 33.18 33.5 34C33.5 34.82 32.82 35.5 32 35.5Z"
              fill="#2563EB"
            />
          </svg>
          <p>آگهی</p>
        </div>
        <div
          onClick={() => {
            onOpenChange(false);
            setOpenSheet('customer');
          }}
          className="text-[#A400F8] border-[#A400F8] bg-[#FBF2FF]"
        >
          <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              opacity="0.8"
              d="M14 11.5C13.18 11.5 12.5 10.82 12.5 10V4C12.5 3.18 13.18 2.5 14 2.5C14.82 2.5 15.5 3.18 15.5 4V10C15.5 10.82 14.82 11.5 14 11.5Z"
              fill="#A400F8"
            />
            <path
              opacity="0.8"
              d="M30 11.5C29.18 11.5 28.5 10.82 28.5 10V4C28.5 3.18 29.18 2.5 30 2.5C30.82 2.5 31.5 3.18 31.5 4V10C31.5 10.82 30.82 11.5 30 11.5Z"
              fill="#A400F8"
            />
            <path
              opacity="0.2"
              d="M40 17V34C40 40 37 44 30 44H14C7 44 4 40 4 34V17C4 11 7 7 14 7H30C37 7 40 11 40 17Z"
              fill="#A400F8"
            />
            <path
              opacity="0.8"
              d="M24 21.5H12C11.18 21.5 10.5 20.82 10.5 20C10.5 19.18 11.18 18.5 12 18.5H24C24.82 18.5 25.5 19.18 25.5 20C25.5 20.82 24.82 21.5 24 21.5Z"
              fill="#A400F8"
            />
            <path
              opacity="0.8"
              d="M18 31.5H12C11.18 31.5 10.5 30.82 10.5 30C10.5 29.18 11.18 28.5 12 28.5H18C18.82 28.5 19.5 29.18 19.5 30C19.5 30.82 18.82 31.5 18 31.5Z"
              fill="#A400F8"
            />
            <circle opacity="0.8" cx="34.5" cy="33.5" r="12.5" fill="#A400F8" />
            <path
              d="M35.0006 33.463C37.4452 33.463 39.427 31.5686 39.427 29.2316C39.427 26.8946 37.4452 25 35.0006 25C32.556 25 30.5742 26.8946 30.5742 29.2316C30.5742 31.5686 32.556 33.463 35.0006 33.463Z"
              fill="#EAC2FE"
            />
            <path
              d="M40.0913 41C41.63 41 42.5229 39.3655 41.6681 38.1487C40.3762 36.3145 37.8686 35.0795 35 35.0795C32.1314 35.0795 29.6238 36.3145 28.3319 38.1487C27.4771 39.3655 28.37 41 29.9087 41H40.0913Z"
              fill="#EAC2FE"
            />
          </svg>
          <p>مشتری</p>
        </div>
        {/* <div className="text-[#F28124] border-[#F28124] bg-[#FFF9F3]">
          <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              opacity="0.4"
              d="M6 15C6 10.5817 9.58172 7 14 7H34C38.4183 7 42 10.5817 42 15V18V36C42 40.4183 38.4183 44 34 44H14C9.58172 44 6 40.4183 6 36V18V15Z"
              fill="#F28124"
            />
            <path d="M34 7H14C9.58172 7 6 10.5817 6 15V18H42V15C42 10.5817 38.4183 7 34 7Z" fill="#F28124" />
            <path
              opacity="0.4"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M16 2.5C16.8284 2.5 17.5 3.17157 17.5 4V10C17.5 10.8284 16.8284 11.5 16 11.5C15.1716 11.5 14.5 10.8284 14.5 10V4C14.5 3.17157 15.1716 2.5 16 2.5ZM32 2.5C32.8284 2.5 33.5 3.17157 33.5 4V10C33.5 10.8284 32.8284 11.5 32 11.5C31.1716 11.5 30.5 10.8284 30.5 10V4C30.5 3.17157 31.1716 2.5 32 2.5Z"
              fill="#F28124"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M24 22.5C24.8284 22.5 25.5 23.1716 25.5 24V28.5H30C30.8284 28.5 31.5 29.1716 31.5 30C31.5 30.8284 30.8284 31.5 30 31.5H25.5V36C25.5 36.8284 24.8284 37.5 24 37.5C23.1716 37.5 22.5 36.8284 22.5 36V31.5H18C17.1716 31.5 16.5 30.8284 16.5 30C16.5 29.1716 17.1716 28.5 18 28.5H22.5V24C22.5 23.1716 23.1716 22.5 24 22.5Z"
              fill="#F28124"
            />
          </svg>
          <p>یادآور</p>
        </div>
        <div className="text-[#2B2E4A] border-[#2B2E4A] bg-[#F4F4FF]">
          <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M24 24V36" stroke="#2B2E4A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path
              d="M40 16V14C40 10.6863 37.3137 8 34 8H28.395C27.0589 8 25.761 7.55404 24.7071 6.7328L22.8262 5.2672C21.7723 4.44596 20.4744 4 19.1383 4H14C10.6863 4 8 6.68629 8 10V16H40Z"
              fill="#2B2E4A"
            />
            <path
              opacity="0.4"
              d="M41.0529 16H6.94879C4.40222 16 2.504 18.3481 3.03758 20.8381L6.64575 37.6762C7.43616 41.3648 10.6959 44 14.4682 44H33.5335C37.3058 44 40.5655 41.3648 41.3559 37.6762L44.9641 20.8381C45.4977 18.3481 43.5995 16 41.0529 16Z"
              fill="#2B2E4A"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M24 22.5C24.8284 22.5 25.5 23.1716 25.5 24V28.5H30C30.8284 28.5 31.5 29.1716 31.5 30C31.5 30.8284 30.8284 31.5 30 31.5L25.5 31.5V36C25.5 36.8284 24.8284 37.5 24 37.5C23.1716 37.5 22.5 36.8284 22.5 36V31.5H18C17.1716 31.5 16.5 30.8284 16.5 30C16.5 29.1716 17.1716 28.5 18 28.5H22.5V24C22.5 23.1716 23.1716 22.5 24 22.5Z"
              fill="#2B2E4A"
            />
          </svg>
          <p>نیازمندی</p>
        </div> */}
        <div
          onClick={() => {
            onOpenChange(false);
            setOpenSheet('agent');
          }}
          className="text-[#1A90B0] border-[#1A90B0] bg-[#FBFEFF]"
        >
          <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              opacity="0.2"
              d="M18 4C12.76 4 8.5 8.26 8.5 13.5C8.5 18.64 12.52 22.8 17.76 22.98C17.92 22.96 18.08 22.96 18.2 22.98C18.24 22.98 18.26 22.98 18.3 22.98C18.32 22.98 18.32 22.98 18.34 22.98C23.46 22.8 27.48 18.64 27.5 13.5C27.5 8.26 23.24 4 18 4Z"
              fill="#1A90B0"
            />
            <path
              opacity="0.8"
              d="M28.1599 28.3C22.5799 24.58 13.4799 24.58 7.85992 28.3C5.31992 30 3.91992 32.3 3.91992 34.76C3.91992 37.22 5.31992 39.5 7.83992 41.18C10.6399 43.06 14.3199 44 17.9999 44C21.6799 44 25.3599 43.06 28.1599 41.18C30.6799 39.48 32.0799 37.2 32.0799 34.72C32.0599 32.26 30.6799 29.98 28.1599 28.3Z"
              fill="#1A90B0"
            />
            <path
              opacity="0.2"
              d="M39.9807 14.68C40.3007 18.56 37.5407 21.96 33.7207 22.42C33.7007 22.42 33.7007 22.42 33.6807 22.42H33.6207C33.5007 22.42 33.3807 22.42 33.2807 22.46C31.3407 22.56 29.5607 21.94 28.2207 20.8C30.2807 18.96 31.4607 16.2 31.2207 13.2C31.0807 11.58 30.5207 10.1 29.6807 8.83999C30.4407 8.45999 31.3207 8.21999 32.2207 8.13999C36.1407 7.79999 39.6407 10.72 39.9807 14.68Z"
              fill="#1A90B0"
            />
            <path
              opacity="0.8"
              d="M43.9805 33.18C43.8205 35.12 42.5805 36.8 40.5005 37.94C38.5005 39.04 35.9805 39.56 33.4805 39.5C34.9205 38.2 35.7605 36.58 35.9205 34.86C36.1205 32.38 34.9405 30 32.5805 28.1C31.2405 27.04 29.6805 26.2 27.9805 25.58C32.4005 24.3 37.9605 25.16 41.3805 27.92C43.2205 29.4 44.1605 31.26 43.9805 33.18Z"
              fill="#1A90B0"
            />
          </svg>
          <p>مشاور</p>
        </div>
      </div>
    </Modal>
  );
}

export default ModalAddContent;
